

import { Component, Vue } from 'vue-property-decorator'
import Footer from '~/components/common/footer/Footer.vue'
import Header from '~/components/common/header/Header.vue'
import Subheader from '~/components/common/header/Subheader.vue'
import PreLoader from '~/components/common/loader/pre-loader/PreLoader.vue'
import AutoApplicationModalProvider from '~/components/common/modals/auto-application-modal/AutoApplicationModalProvider.vue'

@Component({
  name: 'MyAccountLayout',
  components: {
    PreLoader,
    Header,
    Subheader,
    Footer,
    AutoApplicationModalProvider
  }
})
export default class MyAccountLayout extends Vue {
  created() {
    if (!this.$auth.loggedIn && !this.$config.useExternalLoginUi) {
      this.$modal.show(Vue.component('ModalAuthentication'), {
        success: () => this.$accessor.initStore(this.$config),
        close: () => (window.location.href = '/')
      })
    }
  }

  get isMobile() {
    return this.$store.getters['screen/resolution'] < 768
  }
}
